import { GetPatientDetailResponseIds } from '@toktokdoctech/tokapi-client'
import { FormatedPatientFormData } from '../_props'

export const transformPatientDetailToFormData = (
    detail: GetPatientDetailResponseIds,
    isAutomaticIdentityValidationDisabled: boolean,
): FormatedPatientFormData => {
    const manualIdentityValidation =
        (isAutomaticIdentityValidationDisabled && ['Validated', 'Qualified'].includes(detail.insiStatus)) || undefined

    return {
        id: detail.id,
        objectId: detail.id,
        firstName: detail.firstName,
        firstFirstName: detail.firstFirstName, // TODO ensure api is updated to include this field
        lastName: detail.lastName,
        fullName: detail.fullName,
        birthName: detail.birthName,
        birthDate: detail.birthDate,
        sex: detail.sex,
        room: detail.room,
        insNum: detail.insNum,
        insOid: detail.insOid,
        socialSecurityNumber: detail.socialSecurityNumber,
        countryBirth: detail.countryBirth,
        birthCityLabel: detail.birthCity?.label,
        patientIsSameAsInsured: detail.patientIsSameAsInsured,
        hasLtDiseases: detail.hasLtDiseases,
        firstNameList: detail.firstNameList,
        patientInsuredUserLabel: detail.patientInsuredUserLabel,
        hasCss: detail.hasCss,
        attendingPhysician: detail.attendingPhysician,
        insuredSsn: detail.insuredSsn,
        identityProof: detail.identityProof,
        contactEmail: detail.contactEmail,
        contactPhone: detail.contactPhone,
        manualIdentityValidation,
        birthCity: {
            com: detail.birthCity?.code || undefined,
            libelle: detail.birthCity?.label || undefined,
        },
        insiStatus: detail.insiStatus,
        insiIdentityAttributes: detail.insiIdentityAttributes,
        address: { city: detail.address?.city, postalCode: detail.address?.postalCode, street: detail.address?.street },
        attachmentOrg: detail.attachmentOrg,
        extUniqId: detail.extUniqId,
    }
}
